import { EnrichedMarkdownText } from "@-/com.npmjs.react-native-enriched-markdown";
import { View } from "@-/com.npmjs.react-native";
import { Surface } from "@-/dev.improve.haniverse.components.ui.surface";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useThemedMarkdownStyle } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.description";
import type { LevelsPackDescription } from "#get-levels-pack-description";

/**
 * What a material tab's pack covers and why it exists. It opens the pack sheet above the level
 * list, ahead of the pack's reference material (the Ready pack's pinyin charts, another pack's
 * progress); a curriculum preview without a sheet shows it as the list's first row instead.
 */
export function LevelsPackDescriptionHeader(props: LevelsPackDescription) {
  return (
    <Surface className="px-3 py-2.5" testID="levels-pack-description">
      <LevelsPackDescriptionContent {...props} />
    </Surface>
  );
}

/** Shared note content for the header and the free learner's sticky upgrade note. */
export function LevelsPackDescriptionContent({
  description,
  lessonCount,
  levelCount,
  scope,
  showHeading = true,
  title,
}: LevelsPackDescription & { showHeading?: boolean }) {
  const markdownStyle = useThemedMarkdownStyle("sm", { tone: "muted" });
  return (
    <View className="gap-1">
      {showHeading ? (
        <View className="flex-row flex-wrap items-baseline gap-x-2">
          <Text className="text-base font-semibold text-foreground">{title}</Text>
          {scope === null ? null : (
            <Text className="text-sm font-medium text-primary">{scope}</Text>
          )}
        </View>
      ) : null}
      {/* Authored markdown: "you'll be **ready**". */}
      <EnrichedMarkdownText markdown={description} markdownStyle={markdownStyle} />
      <Text className="text-xs text-muted-foreground">
        {lessonCount.toLocaleString()} lessons · {levelCount} levels
      </Text>
    </View>
  );
}
